import React, { useEffect, useRef } from "react";
import hljs from "highlight.js";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";

import "./ECLRichTextCodeBlock.css";

export default function ECLRichTextCodeBlock(props) {
   const codeRef = useRef(null);
   const instanceID = useSelectorId();

   useEffect(() => {
      hljs.highlightElement(codeRef.current);
      const loc = codeRef.current.getClientRects();
      for (let i = 0; i < loc.length; i++) {
         document
            .querySelector("#lines-" + instanceID)
            .append(document.createElement("span"));
      }
   }, []);
   const source = props.children[0] || "";

   return (
      <div className="rich-text-code-block">
         <div className="numbered-lines" id={"lines-" + instanceID} />
         <div>
            <code
               ref={codeRef}
               className={
                  props.className
                     ? props.className.replace("language-", "")
                     : ""
               }
            >
               {source}
            </code>
         </div>
      </div>
   );
}
